// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"187":"494235b2","382":"461d8699","734":"2373bfe4","761":"c54f6209","775":"323c1a4a"}[chunkId] + ".chunk.css";
};